<div class="execution-control" [attr.aria-busy]="loadingexecutions">
  <tds-dropdown #dropdown [name]="'execution-' + fpcfamily" size="sm" open-direction="down" modeVariant="secondary" animation="none"
    [tdsAriaLabel]="'New configuration for FPC ' + fpcfamily"
    [placeholder]="executionDisplayText"
    [value]="selectedValue" [disabled]="readOnly"
    (pointerdown)="getExecutions()" (keydown)="onKeydown($event)" (tdsBlur)="clearExecutions()"
    (tdsChange)="selectExecution($event.detail.value)">
    <tds-dropdown-option *ngFor="let item of displayedExecutions; trackBy: trackExecution" [value]="item.Execution"
      [tdsAriaLabel]="optionLabel(item) + ', execution ' + item.Execution">
      <label class="execution-option-label" [style.font-weight]="item.Recommended ? 'bold' : 'normal'"
        [title]="'Execution: ' + item.Execution">{{ optionLabel(item) }}</label>
    </tds-dropdown-option>
    <tds-dropdown-option *ngIf="executions?.length === 0" value="__empty" disabled>No configurations available</tds-dropdown-option>
  </tds-dropdown>
  <tds-spinner *ngIf="loadingexecutions" class="execution-loading" size="xs" variant="standard" aria-hidden="true"></tds-spinner>
  <button *ngIf="loadFailed" type="button" class="execution-retry" (click)="getExecutions()">Retry</button>
  <span class="sr-only" aria-live="polite">{{ loadingexecutions ? 'Loading configurations' : loadFailed ? 'Could not load configurations. Use Retry.' : executions?.length === 0 ? 'No configurations available' : '' }}</span>
</div>
